import * as Preact from 'preact';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Figma design nodes:
 * Mobile: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9710%3A59825
 * Desktop: https://www.figma.com/file/va7snk88pL7TR7F75h7zbt/Design-Files?node-id=9715%3A59999
 */

export type Props = {
    question: string;
    propertyName: string;
    currentOptionText: string;
    content?: string;
    disabled: boolean;
    nullOptionText: string;
    focus: boolean;
};

export const cardHeight = 171;
export const cardWidthMobile = 149;
export const cardWidthDesktop = 201;

export const Component = (p: Props) => (
    <Box
        sx={{
            backgroundColor: 'background.default',
            p: '12px',
            borderRadius: '8px',
            gap: '12px',
            alignItems: 'center',
            width: { xs: cardWidthMobile, md: cardWidthDesktop },
            height: cardHeight,
            boxSizing: 'border-box',
            display: 'grid',
            gridTemplateRows: '70px 1fr',
            flexShrink: '0',
        }}
    >
        {!p.disabled ? (
            <>
                {p.content ? (
                    <img
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        src={p.content}
                    />
                ) : (
                    <Box></Box>
                )}
            </>
        ) : (
            <Box></Box>
        )}
        <Box width="100%" overflow="hidden">
            <Typography
                width="100%"
                textAlign="center"
                variant="h6"
                color={p.disabled ? 'text.disabled' : 'secondary'}
                noWrap={true}
            >
                {p.question}
            </Typography>
            <Box display="flex" justifyContent="center" alignItems="center" height="36px">
                <Typography
                    width="100%"
                    textAlign="center"
                    variant="body1"
                    color={p.disabled ? 'text.disabled' : 'secondary'}
                    noWrap={true}
                >
                    {p.currentOptionText === null ? p.nullOptionText : p.currentOptionText}
                </Typography>
            </Box>
        </Box>
    </Box>
);
